import { render, staticRenderFns } from "./DiscountApi.vue?vue&type=template&id=aba3bb52&scoped=true&"
import script from "./DiscountApi.vue?vue&type=script&lang=js&"
export * from "./DiscountApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba3bb52",
  null
  
)

export default component.exports